"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitionPricingOperation = void 0;
var __1 = require("../../");
var matcher_1 = require("../matcher");
var basePricingOperation_1 = require("./basePricingOperation");
var CompetitionPricingOperation = /** @class */ (function (_super) {
    __extends(CompetitionPricingOperation, _super);
    function CompetitionPricingOperation(_a) {
        var superParams = __rest(_a, []);
        var _this = _super.call(this, superParams) || this;
        _this.getFreshnessValue = function (_date) {
            var date = new Date(_date).getTime();
            if (date > Date.now() - 1000 * 60 * 60 * 2)
                return 1;
            else if (date > Date.now() - 1000 * 60 * 60 * 24)
                return 2;
            return 3;
        };
        _this.filterViableOptions = function (articleData) {
            var viableOptions = matcher_1.ArticleMatcher.getMatchingArticles({
                article: _this.article,
                competitor: _this.competitor,
                playsetCount: _this.gameSettings.playsetCount,
                strategy: _this.strategy,
                articleData: articleData,
                limit: _this.searchMode === 'rank' ? _this.parameterValue : undefined,
            });
            return viableOptions;
        };
        _this.findBaseArticleFromOptions = function (viableOptions) {
            if (_this.searchMode === 'rank') {
                return viableOptions[Math.min(viableOptions.length, _this.parameterValue) - 1];
            }
            else if (_this.searchMode === 'percentile') {
                var position = Math.floor(_this.parameterValue / 100 / (1 / viableOptions.length));
                return viableOptions[position];
            }
            else
                throw new Error('searchMode not supported');
        };
        _this.getBaseArticle = function (articleData) {
            var viableOptions = _this.filterViableOptions(articleData);
            if (!viableOptions.length)
                throw new Error('could not find an article that matches the competitor');
            var baseArticle = _this.findBaseArticleFromOptions(viableOptions);
            return baseArticle;
        };
        // find cheapest article that matches language and condition
        // of input article
        _this.getCheapestArticle = function (articleData) {
            var anyCompetitor = {
                countries: [],
                reputation: __1.Reputation.Average,
                level: __1.SellerLevel.Private,
                source: __1.PRICING_BOT_SOURCE.CARDMARKET,
                onlyCardtraderZero: false,
            };
            var viableOptions = matcher_1.ArticleMatcher.getMatchingArticles({
                article: _this.article,
                competitor: anyCompetitor,
                playsetCount: _this.gameSettings.playsetCount,
                strategy: _this.strategy,
                articleData: articleData,
                limit: undefined,
            });
            var cheapestArticle = viableOptions[0];
            viableOptions.forEach(function (article) {
                if (article.price < cheapestArticle.price) {
                    cheapestArticle = article;
                }
            });
            return cheapestArticle;
        };
        _this.competitor = _this.strategy.base.tactic.competitor;
        if (!_this.competitor)
            throw new Error('competitor is not defined');
        return _this;
    }
    Object.defineProperty(CompetitionPricingOperation.prototype, "searchMode", {
        get: function () {
            return this.strategy.base.tactic.parameterType === 'percentile' ? 'percentile' : 'rank';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompetitionPricingOperation.prototype, "parameterValue", {
        get: function () {
            return Number(this.strategy.base.tactic.parameter);
        },
        enumerable: false,
        configurable: true
    });
    CompetitionPricingOperation.prototype.execute = function (articleData, getCheapestArticle) {
        if (getCheapestArticle === void 0) { getCheapestArticle = false; }
        var baseArticle = this.getBaseArticle(articleData);
        if (!baseArticle)
            throw new Error('could not find a base article');
        var basePrice = baseArticle[this.priceAttribute] * this.playsetCoefficient(baseArticle.isPlayset);
        var priceModification = this.getNewPrice(basePrice);
        if (!priceModification.newPrice)
            throw new Error('could not find a new price');
        var minPrice = priceModification.newPrice;
        if (getCheapestArticle) {
            var cheapestArticle = this.getCheapestArticle(articleData);
            // minPrice can never be lower than the bulk value
            if (this.strategy.bulkSettingsId[this.idGame] && cheapestArticle) {
                minPrice = Math.max(this.bulkValue, cheapestArticle.price);
            }
        }
        var priceReport = {
            price: priceModification.newPrice,
            pricingStrategy: this.strategy,
            minPrice: minPrice,
            base: {
                type: 'competition',
                value: baseArticle.attributes,
                usedBulkPrice: priceModification.usedBulkPrice,
                hitDecreaseCap: priceModification.usedBulkPrice,
                hitIncreaseCap: priceModification.hitIncreaseCap,
                freshness: this.getFreshnessValue(articleData.fetchedAt),
            },
        };
        return priceReport;
    };
    return CompetitionPricingOperation;
}(basePricingOperation_1.BasePricingOperation));
exports.CompetitionPricingOperation = CompetitionPricingOperation;
//# sourceMappingURL=competitionPricingOperation.js.map